import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Helper canónico de shadcn/ui — combina `clsx` (composición condicional)
 * con `tailwind-merge` (resolución determinística de conflictos Tailwind).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
